module.exports = __webpack_public_path__ + "static/media/ios-color-fill.c4c0a7a5.svg";